import { Stack, createStyles } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import { IconAlertCircle } from '~/domains/design-system/icons/IconAlertCircle';
import dt from '~/testing';

const dtIds = dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal;

const useStyles = createStyles((theme) => ({
  container: {
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '16px 24px 32px',
    alignItems: 'center',
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 8px',
    backgroundColor: theme.colors.gray[1],
    borderRadius: '50%',
    width: 56,
    height: 56,
  },
  title: {
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
  },
  content: {
    maxWidth: 420,
  },
  actions: {
    width: '100%',
    maxWidth: 420,
    marginTop: theme.other.spacing._12,
  },
}));

type TooManyAttemptsContentProps = {
  onContactSupport: () => void;
  onCancel: () => void;
};

export default function TooManyAttemptsContent({
  onContactSupport,
  onCancel,
}: TooManyAttemptsContentProps) {
  const { t } = useTranslation('auth');
  const { classes, theme } = useStyles();

  return (
    <Stack className={classes.container}>
      <div className={classes.content}>
        <div className={classes.iconContainer}>
          <IconAlertCircle size={28} color={theme.colors.dark[9]} />
        </div>
        <Title
          data-test-id={dtIds.title}
          variant="subhead-x-large"
          weight={700}
          className={classes.title}
        >
          {t('signUp.tooManyAttempts.title')}
        </Title>
        <Text data-test-id={dtIds.description} variant="body-large" color="gray.7">
          {t('signUp.tooManyAttempts.copy')}
        </Text>
      </div>
      <Stack className={classes.actions}>
        <Button
          data-test-id={dtIds.contactSupportButton}
          variant="primary-fill"
          size="large-icon"
          onClick={onContactSupport}
        >
          {t('signUp.tooManyAttempts.contactSupport')}
        </Button>
        <Button data-test-id={dtIds.cancelButton} variant="tertiary-fill" onClick={onCancel}>
          {t('signUp.tooManyAttempts.cancel')}
        </Button>
      </Stack>
    </Stack>
  );
}
